import { Icon, Tooltip } from '@ksyos/design-system';
import { CardiologyMedicationLabel } from '@common/validation/customControls/cardiology/holter/utils/medicationUtils';

export function PlaatjesRemmersTooltipLabel(props: Readonly<{ label: string }>) {
    const { label } = props;
    if (label === CardiologyMedicationLabel.plaatjesAggregatieRemmers) {
        return (
            <>
                {label}
                <Tooltip content={'Plaatjesremmers vallen niet onder antistolling'}>
                    <Icon
                        color="primary"
                        icon="information"
                        sx={{ marginLeft: 2 }}
                    />
                </Tooltip>
            </>
        );
    }

    return label;
}
